import { render, staticRenderFns } from "./BroadcastButton.vue?vue&type=template&id=3289641f&scoped=true&lang=pug"
import script from "./BroadcastButton.vue?vue&type=script&lang=ts"
export * from "./BroadcastButton.vue?vue&type=script&lang=ts"
import style0 from "./BroadcastButton.vue?vue&type=style&index=0&id=3289641f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3289641f",
  null
  
)

export default component.exports